import { HttpEvent, HttpEventCallbacks, httpGet, httpPost } from "@/events/eventsDomain";
import type { CustomFieldDefinition } from "./customFieldsDomain";
import type {
  EntityDataImportRequest,
  EntityDataImportResponse,
  EntityDataImportSheet,
} from "./entityDataImportDomain";
import type {
  CompanyRoleImportRequest,
  CompanyRoleImportResponse,
  CompanyRoleImportSheet,
} from "./companyRoleImportDomain";

const companyRoleImportBase = (accountId: string) =>
  `/enterprise-accounts/${encodeURIComponent(accountId)}/company-roles/spreadsheet`;

const entityDataImportBase = (accountId: string) =>
  `/enterprise-accounts/${encodeURIComponent(accountId)}/entity-data/spreadsheet`;

export const customFieldsApiClient = {
  definitions: (
    accountId: string,
    params: HttpEventCallbacks<CustomFieldDefinition[]>,
  ): HttpEvent<CustomFieldDefinition[]> =>
    httpGet({
      url: `/enterprise-accounts/${encodeURIComponent(accountId)}/custom-fields`,
      ...params,
    }),
  readEntityDataImport: (
    accountId: string,
    file: File,
    params: HttpEventCallbacks<EntityDataImportSheet>,
  ): HttpEvent<EntityDataImportSheet> => {
    const data = new FormData();
    data.append("file", file);
    return httpPost({ url: entityDataImportBase(accountId), data, ...params });
  },
  validateEntityDataImport: (
    accountId: string,
    data: EntityDataImportRequest,
    params: HttpEventCallbacks<EntityDataImportResponse>,
  ): HttpEvent<EntityDataImportResponse> =>
    httpPost({ url: `${entityDataImportBase(accountId)}/validate`, data, ...params }),
  importEntityData: (
    accountId: string,
    data: EntityDataImportRequest,
    params: HttpEventCallbacks<EntityDataImportResponse>,
  ): HttpEvent<EntityDataImportResponse> =>
    httpPost({ url: `${entityDataImportBase(accountId)}/import`, data, ...params }),
  readCompanyRoleImport: (
    accountId: string,
    file: File,
    params: HttpEventCallbacks<CompanyRoleImportSheet>,
  ): HttpEvent<CompanyRoleImportSheet> => {
    const data = new FormData();
    data.append("file", file);
    return httpPost({ url: companyRoleImportBase(accountId), data, ...params });
  },
  validateCompanyRoleImport: (
    accountId: string,
    data: CompanyRoleImportRequest,
    params: HttpEventCallbacks<CompanyRoleImportResponse>,
  ): HttpEvent<CompanyRoleImportResponse> =>
    httpPost({ url: `${companyRoleImportBase(accountId)}/validate`, data, ...params }),
  importCompanyRoles: (
    accountId: string,
    data: CompanyRoleImportRequest,
    params: HttpEventCallbacks<CompanyRoleImportResponse>,
  ): HttpEvent<CompanyRoleImportResponse> =>
    httpPost({ url: `${companyRoleImportBase(accountId)}/import`, data, ...params }),
};
